import React from "react";
import UsersForm from "../components/settingsForms/UsersForm";
import LoginInfoForm from "../components/settingsForms/LoginInfoForm";
import PreferencesForm from "../components/settingsForms/PreferencesForm";

const Settings = ({ isMobile }) => {
  return (
    <div
      className={`flex h-full w-full flex-col gap-4 overflow-hidden ${
        isMobile ? "items-center" : ""
      } overflow-y-auto bg-backgroundPrimary p-6 text-textPrimary 2xl:flex-row 2xl:items-stretch`}
    >
      <div className="flex w-full flex-col justify-between gap-4 2xl:flex-[3]">
        {/* Users */}
        <div className="w-full rounded bg-inputBackground p-6 text-textPrimary shadow-lg 2xl:h-[55%]">
          <UsersForm isMobile={isMobile} />
        </div>
        {/* Login Info */}
        <div className="w-full rounded bg-inputBackground p-6 text-textPrimary shadow-lg 2xl:h-[40%]">
          <LoginInfoForm isMobile={isMobile} />
        </div>
      </div>
      {/* Preferences */}
      <div className="w-full rounded bg-inputBackground p-6 text-textPrimary shadow-lg 2xl:flex-[1]">
        <PreferencesForm isMobile={isMobile} />
      </div>
    </div>
  );
};

export default Settings;
